<mat-button-toggle-group class="without-checked-state">
  <mat-button-toggle
    matTooltip="Undo"
    (click)="undo({ source: 'button' })"
    [disabled]="(undoService.canUndo$ | async) === false"
  >
    <fa-icon [icon]="faUndo" [fixedWidth]="true"></fa-icon>
  </mat-button-toggle>
  <mat-button-toggle
    matTooltip="Redo"
    (click)="redo({ source: 'button' })"
    [disabled]="(undoService.canRedo$ | async) === false"
  >
    <fa-icon [icon]="faRedo" [fixedWidth]="true"></fa-icon>
  </mat-button-toggle>
</mat-button-toggle-group>
